// withCredentials is only for our API. A global axios default would also attach
// the session cookie to third parties (Mailchimp, and any other absolute URL).

export function originOf(url) {
	try {
		return new URL(url).origin
	} catch {
		return ''
	}
}

export function isFirstPartyApiUrl(url, origins) {
	if (!url || typeof url !== 'string') return false
	if (url.startsWith('/')) return false
	const origin = originOf(url)
	if (!origin) return false
	return (origins || []).some((base) => originOf(base) === origin)
}

export function installApiCredentials(http, { origins = [] } = {}) {
	if (!http?.interceptors?.request?.use || http.__ihhApiCredentials) return http
	http.__ihhApiCredentials = true
	http.interceptors.request.use((config) => {
		const relative = config?.url && config?.baseURL && !/^https?:/i.test(config.url)
		let url = config?.url || ''
		if (relative) {
			try {
				url = new URL(config.url, config.baseURL).href
			} catch {
				url = config.url
			}
		}
		if (isFirstPartyApiUrl(url, origins)) config.withCredentials = true
		return config
	})
	return http
}
